import React from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { DateField as OriginalField } from '../DateField';

interface IProps<TFieldValues extends FieldValues = FieldValues>
  extends UseControllerProps<TFieldValues>,
    Omit<
      React.ComponentProps<typeof OriginalField>,
      'name' | 'value' | 'defaultValue' | 'onChange' | 'error' | 'required'
    > {
  isRequired?: boolean;
}

const DateField = <TFieldValues extends FieldValues = FieldValues>({
  description,
  name,
  rules,
  control,
  defaultValue,
  shouldUnregister,
  isRequired,
  ...inputProps
}: IProps<TFieldValues>) => {
  const intl = useIntl();

  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules: {
      required: isRequired
        ? {
            value: true,
            message: intl.formatMessage({
              defaultMessage: 'Field is required.',
              id: 'Q4ipsb',
              description: 'Required field validation message',
            }),
          }
        : undefined,
      ...rules,
    },
    shouldUnregister,
  });

  const handleChange = (event: React.ChangeEvent, { value }: { value: Date | null }) => {
    field.onChange(value);
  };

  return (
    <OriginalField
      {...field}
      {...inputProps}
      inputRef={ref}
      onChange={handleChange}
      value={field.value}
      error={error?.message}
      description={description}
    />
  );
};

export { DateField };
